import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { apiWrapper } from "../../../api/apiWrapper";
import { IBaseResponeModel } from '../../../models/response/base-response';
import { ts_phuhuynh_adm_status } from '../../../models/response/category/ts_phuhuynh_adm_status';
import { eTrangThaiPhuHuynhActionTypeIds, ITrangThaiPhuHuynhActionTypes } from '../../action-types/trang-thai-phu-huynh/ITrangThaiPhuHuynhActionTypes';
import { actions } from '../../actions/actionsWrapper';
const crmSurveyFormWrapperAction= actions.crmSurveyFormWrapper;
export function* trangThaiPhuHuynhSaga(): any {
    yield takeLatest(eTrangThaiPhuHuynhActionTypeIds.LOAD_START, loadWorker)
    yield takeLatest(eTrangThaiPhuHuynhActionTypeIds.LOAD_CHECKDANGKY_START, loadCheckDangKyWorker)
    yield takeLatest(eTrangThaiPhuHuynhActionTypeIds.LOAD_COSO_START, loadCosoWorker)
    yield takeEvery(eTrangThaiPhuHuynhActionTypeIds.SAVE_START, saveWorker)
    yield takeEvery(eTrangThaiPhuHuynhActionTypeIds.UPDATE_START, updateWorker)
    yield takeEvery(eTrangThaiPhuHuynhActionTypeIds.DELETE_START, deleteWorker)
}

function* loadWorker(): any {
    const res: IBaseResponeModel = yield call(apiWrapper.trangThaiPhuHuynh.selectAll)
    if (res.is_success) {
        yield put(crmSurveyFormWrapperAction.trangThaiPhuHuynh.LOAD_SUCCESS(res.data))
    } else {
        yield put(crmSurveyFormWrapperAction.trangThaiPhuHuynh.LOAD_ERROR(res.message ?? "Error"))
    }
}

function* loadCheckDangKyWorker(data: any): any {
    const res: IBaseResponeModel = yield call([apiWrapper.trangThaiPhuHuynh, apiWrapper.trangThaiPhuHuynh.selectAllCheckDangKy], data.payload)
    if (res.is_success) {
        yield put(crmSurveyFormWrapperAction.trangThaiPhuHuynh.LOAD_CHECKDANGKY_SUCCESS(res.data))
    } else {
        yield put(crmSurveyFormWrapperAction.trangThaiPhuHuynh.LOAD_CHECKDANGKY_ERROR(res.message ?? "Error"))
    }
}

function* loadCosoWorker(data: any): any {
    const res: IBaseResponeModel = yield call([apiWrapper.trangThaiPhuHuynh, apiWrapper.trangThaiPhuHuynh.selectByCoSo], data.payload)
    if (res.is_success) {
        yield put(crmSurveyFormWrapperAction.trangThaiPhuHuynh.LOAD_COSO_SUCCESS(res.data))
    } else {
        yield put(crmSurveyFormWrapperAction.trangThaiPhuHuynh.LOAD_COSO_ERROR(res.message ?? "Error"))
    }
}

function* saveWorker(action: ITrangThaiPhuHuynhActionTypes): any {
    const payload: ts_phuhuynh_adm_status = action.payload as ts_phuhuynh_adm_status;
    let res: IBaseResponeModel;
    if (payload.id > 0) {
        res = yield call(apiWrapper.trangThaiPhuHuynh.update, payload)
    } else {
        res = yield call(apiWrapper.trangThaiPhuHuynh.insert, payload)
    }
    if (res.is_success) {
        yield put(crmSurveyFormWrapperAction.trangThaiPhuHuynh.SAVE_SUCESS(res.data))
    } else {
        yield put(crmSurveyFormWrapperAction.trangThaiPhuHuynh.SAVE_ERROR(res.message ?? "Error"))
    }
}

function* updateWorker(action: ITrangThaiPhuHuynhActionTypes): any {
    const payload: ts_phuhuynh_adm_status = action.payload as ts_phuhuynh_adm_status;
    const res: IBaseResponeModel = yield call(apiWrapper.trangThaiPhuHuynh.update, payload)
    if (res.is_success) {
        yield put(crmSurveyFormWrapperAction.trangThaiPhuHuynh.UPDATE_SUCCESS(res.data))
    } else {
        yield put(crmSurveyFormWrapperAction.trangThaiPhuHuynh.UPDATE_ERROR(res.message ?? "Error"))
    }
}


function* deleteWorker(action: ITrangThaiPhuHuynhActionTypes): any {
    const payload: number = action.payload as number;
    const res: IBaseResponeModel = yield call(apiWrapper.trangThaiPhuHuynh.delete, payload)
    if (res.is_success) {
        yield put(crmSurveyFormWrapperAction.trangThaiPhuHuynh.DELETE_SUCCESS(undefined))
    } else {
        yield put(crmSurveyFormWrapperAction.trangThaiPhuHuynh.DELETE_ERROR(res.message ?? "Error"))
    }
}